// eslint-disable-next-line
import React, { Component } from "react";

function CountDown (props)
{
    let styleC = { display: "block" };

    if (!props.countDown) {
      styleC = { display: "none" };
    }

    return (
      <div className="field-countDown" style={styleC}>
        {props.countDown}
      </div>
    );
}
export default CountDown